<template>
  
  <div>
  
      <scroll-menu v-if="computeShow" class="thumbnail-scroller" :space-even="false">
        
        <scroll-image class="scroll-image" @click.native="clickedThumbnail(index)" v-for="(media,index) in computeMediaList" :key="index" :class="{'single-active':getActiveThumb(index)}" :src="media.thumbnail">
          <div class="selected" :class="{'show-selected':computeMultiSelected(index)}"><ui-icon icon='check'/></div>
          <!--<div class="filename">{{media.filename || media.type}}</div>-->
        </scroll-image>
       
      </scroll-menu>
  
  </div>

</template>

<script>

import { eventBus } from '../../services/EventBus.js';
import UiIcon from '../../components/UiIcon.vue';
import ScrollMenu from '../../components/scrollMenu/ScrollMenu.vue';
import ScrollImage from '../../components/scrollMenu/ScrollImage.vue';
import { GALLERY_MODE } from './GALLERY_MODE.js';

export default {
  name: 'caroussel-gallery',
  props:{
    medias:{type:Array,default:()=>{[]}},
    mode:{default:GALLERY_MODE.NORMAL},
    
  },
  data(){
    return {
      position:0,
      selected:[], // if in multi select mode
      updateKey:0,
    }
  },
  components: {
    UiIcon,
    ScrollMenu,
    ScrollImage,
  },
  computed:{
    mediaLength:function(){
      return this.medias ? this.medias.length: 0;
    },
    computeShow(){
     
      if(this.mediaLength>1 || this.mode==GALLERY_MODE.SELECT_MULTIPLE){
        return true;
      }
      return false;
    },
    // compute thumbnails for media types that have no thumbs..
    computeMediaList(){
      var output;
      try{
           // copy list
           output=this.medias.map(
            (item)=>{
             
            //var mimetype=item.url.split(".").slice(-1).pop();
            switch(item.type){
              case "pdf":
                item.thumbnail=require('../../assets/pdf_bg.png');
              break;
              case "mp3":
                item.thumbnail=require('../../assets/audio_bg.png');
              break;
              default:
                // default thumbnail
                item.thumbnail=item.url;
            }
             // check extension..
             
             return item
            });
         }catch(e){
           output=[];
         }
        return output;
    },
    
  },
  methods:{
    computeMultiSelected(index){
      var isSelected=this.selected.indexOf(index);
      if(isSelected!=-1){return true}
      return false;
    },
    getActiveThumb(index){
      if(this.mode==GALLERY_MODE.SELECT_MULTIPLE){
       return false
      }
      if(this.position==index){
        
        return true;//{borderColor:'#0096e2'};
      }
      return false
    },
    clickedThumbnail(index){
      
      if(this.mode==GALLERY_MODE.SELECT_MULTIPLE){
        
        var existing_index=this.selected.indexOf(index);
        if(existing_index!=-1){
          this.selected.splice(existing_index,1);
          
        }else{
          this.selected.push(index);
        }
        
      }

      this.position=index;

      // emit list with selected indexes
      this.$emit('input',index); // this also makes the caroussel go to the right index
      this.$emit('selection',this.selected); // returns the selected list
      
    },
    updatePosition(payload){
     
      this.position=payload.position;
    },
    
    addListeners(){
     // just update position from event
      
      eventBus.$on("CAROUSSEL_IMG_ROTATION",this.updatePosition);
    },
    removeListeners(){
      // just update position from event
      eventBus.$off("CAROUSSEL_IMG_ROTATION",this.updatePosition);
      
    },
   
  },
  beforeDestroy(){
    this.removeListeners();
  },
  mounted(){
    
    this.updateKey=new Date().getTime();
    
    this.addListeners();
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* for multi select "v" overlay */
.selected{
  background-color:rgba(0,0,0,.2);
  position:absolute;
  top:0;
  left:0;
  display:flex;
  width:100%;
  height:100%;
  justify-content: center;
  align-items: center;
  opacity:0;
  transition:opacity .25s ease-in-out;
}
.show-selected{
  opacity:1;
}
/* single thumb has active border, normal mode */
.single-active{
  border-color:#0096e2;
}
.scroll-image{
  overflow:hidden;
}
.filename{
  width:100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align:right;
  overflow:hidden;
  position:absolute;
  bottom:0;
  right:0;
  color:#FFFFFF;
  font-size:.65em;
  padding:4px;
  text-shadow:0px 0px 1px rgba(0,0,0,1);
}
</style>
